import { graphql } from 'gatsby';
import { Anchor } from '@twilio-paste/anchor';
import { Box } from '@twilio-paste/box';
import { Text } from '@twilio-paste/text';
import { Paragraph } from '@twilio-paste/paragraph';
import { Disclosure, DisclosureHeading, DisclosureContent } from '@twilio-paste/disclosure';
import { Tooltip } from '@twilio-paste/tooltip';
import { Stack } from '@twilio-paste/stack';
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import { SuccessIcon } from "@twilio-paste/icons/esm/SuccessIcon";
import { WarningIcon } from "@twilio-paste/icons/esm/WarningIcon";
import { ErrorIcon } from "@twilio-paste/icons/esm/ErrorIcon";
import * as React from 'react';
export default {
  graphql,
  Anchor,
  Box,
  Text,
  Paragraph,
  Disclosure,
  DisclosureHeading,
  DisclosureContent,
  Tooltip,
  Stack,
  Callout,
  CalloutTitle,
  CalloutText,
  SuccessIcon,
  WarningIcon,
  ErrorIcon,
  React
};